import React from 'react';
import { IconProps } from '../../../types/header.types';
import searchIcon from '../../../../assets/b19e8189f67751048bfc7991b71d048b20f2550a.svg';

const SearchIcon: React.FC<IconProps> = ({ 
  size = 16, 
  color = '#68727d', 
  className = '' 
}) => {
  return (
    <div 
      className={`search-icon ${className}`}
      style={{ 
        width: size, 
        height: size,
        '--icon-color': color 
      } as React.CSSProperties}
    >
      <img 
        src={searchIcon} 
        alt="Search" 
        width={size} 
        height={size}
        style={{ filter: color !== '#68727d' ? `brightness(0) saturate(100%)` : undefined }}
      />
    </div>
  );
};

export default SearchIcon;
